
<template>
    <div class="rule-content">
       <div class="text-white max-h-[calc(587px-81px-76px)] overflow-y-auto">
                <div class="bg-title">{{$t('niuniu.cardTypeIntroTitle')}}</div>
                <div class="card-introduction">
                    <div class="card-title bg-[#1B2636]">
                        <ul>
                            <li class="py-[12px]">{{$t('niuniu.cardTypeTitle')}}</li>
                            <li class="py-[12px]">{{$t('niuniu.oddsTitle')}}</li>
                            <li class="py-[12px]">{{$t('niuniu.explanationTitle')}}</li>
                            <li class="py-[12px]">{{$t('niuniu.exampleTitle')}}</li>
                        </ul>
                    </div>
                    <div class="card-list">
                        <ul class="font-[400]">
                            <li class="flex items-stretch flex-nowrap" v-for="(item,index) in cardIntroductions" :key="index">
                                <div class="card-list_type bg-[#1B2636] text-[12px] flex items-center justify-center gap-[2px] leading-tight">
                                    <!-- 特殊牌型：优先判断，避免被普通牛牌型匹配 -->
                                    <template v-if="item.cardType === 'Five Picture' || item.cardType === '五花牛'">
                                        <span class="leading-tight" v-if="locale === 'cn'">五花</span>
                                        <div v-else class="flex flex-col justify-center items-center text-center">
                                            <div class="leading-tight">Five Picture</div>
                                            <IconSvgUse use="icon-cow-red" size="14px"/>
                                        </div>
                                    </template>
                                    <template v-else-if="item.cardType === 'Four of a Kind' || item.cardType === '四炸'">
                                        <span class="leading-tight" v-if="locale === 'cn'">四炸</span>
                                        <div v-else class="flex flex-col justify-center items-center text-center">
                                            <div class="leading-tight">Four</div>
                                            <div class="leading-tight">of</div>
                                            <div class="leading-tight">a Kind</div>
                                        </div>
                                    </template>
                                    <template v-else-if="item.cardType === 'Five Small Cards' || item.cardType === '五小牛'">
                                        <span class="leading-tight" v-if="locale === 'cn'">五小</span>
                                        <div v-else class="flex flex-col justify-center items-center text-center">
                                            <div class="leading-tight">Five Small</div>
                                            <IconSvgUse use="icon-cow-red" size="14px"/>
                                        </div>
                                    </template>
                                    <!-- 普通牛牌型 -->
                                    <template v-else-if="locale === 'cn' && item.cardType === '牛牛'">
                                        <span class="leading-tight">牛</span>
                                        <IconSvgUse use="icon-cow" size="14px"/>
                                    </template>
                                    <template v-else-if="locale === 'cn' && item.cardType.includes('牛')">
                                        <span class="leading-tight">{{ item.cardType.split('牛')[0] }}</span>
                                        <IconSvgUse use="icon-cow" size="14px"/>
                                        <span class="leading-tight">{{ item.cardType.split('牛')[1] }}</span>
                                    </template>
                                    <template v-else-if="item.cardType === 'Bull Bull'">
                                        <span class="leading-tight">Bull</span>
                                        <IconSvgUse use="icon-cow" size="14px"/>
                                    </template>
                                    <template v-else-if="item.cardType === 'No Bull'">
                                        <span class="leading-tight">No</span>
                                        <IconSvgUse use="icon-cow" size="14px"/>
                                    </template>
                                    <template v-else-if="item.cardType.includes('Bull') && item.cardType !== 'Bull Bull'">
                                        <IconSvgUse use="icon-cow" size="14px"/>
                                        <span class="leading-tight">{{ item.cardType.replace('Bull', '').trim() }}</span>
                                    </template>
                                    <template v-else>
                                        <span class="leading-tight pl-[4px]">{{ item.cardType }}</span>
                                    </template>
                                </div>
                                <div class="card-list_odds bg-[#0F172A] text-[10px] py-[5px] flex flex-col items-center justify-center">
                                    <div class=" text-center" v-for="(i,j) in item.odds" :key="j">{{ i }}</div>
                                </div>
                                <div class="card-list_directions bg-[#0F172A]  text-[10px]  p-[5px] text-center flex justify-center items-center">{{ item.directions }}</div>
                                <div class="card-list_pokers p-[5px]  bg-[#0F172A] relative">
                                    <PokerCard v-for="(card, index) in item.pokers" :key="index" :class="{
                                            'pocker-img0': index === 0,
                                            'pocker-img1': index === 1,
                                            'pocker-img2': index === 2,
                                            'pocker-img3': index === 3,
                                            'pocker-img4': index === 4,
                                            'rules-face-up': true
                                        }" :card="card"
                                        width="24px" height="24px" :isFaceUpProp="true" />
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="rule-list" v-for="(item,index) in colList" :key="index">
                    <div class="bg-title mt-[16px]">{{ item.title }}</div>
                    <ul>
                        <li class="text-[14px] font-[500] text-grey-20 leading-[20px] tracking-[0.3px]" v-for="(i,j) in item.infos" :key="j">
                            <div v-if="index < 3" class="flex flex-nowrap">
                                <div class="mr-[3px]">{{ j+1 }}.</div>
                                <div v-html="i"></div>
                            </div>
                            <div v-else v-html="i"></div>
                        </li>
                    </ul>
                </div>
            </div>
    </div>
</template>

<script lang="ts" setup> 
import PokerCard from '~/pages/casino/niuniuGame/_components/PokerCard.vue';
import { getCardsDetailFromIds } from '~/pages/casino/niuniuGame/ts/cardConstants';

const { t: $tFn, locale } = useNuxtApp().$i18n;

const cardIntroductions = ref([
    {
        cardType: $tFn('niuniu.noNiu'),
        odds: ['1'], 
        pokers: getCardsDetailFromIds([48,44,32,28,24]),
        directions: $tFn('niuniu.noNiuExplanation'),
    },
    {
        cardType: $tFn('niuniu.niuOne'),
        odds: ['1'],
        pokers: getCardsDetailFromIds([48,44,40,36,2]),
        directions: $tFn('niuniu.niuOneExplanation'),
    },
    {
        cardType: $tFn('niuniu.niuTwo'),
        odds: [
            $tFn('niuniu.hallOdds3x1') + 1,
            $tFn('niuniu.hallOdds5x1') + 1,
            $tFn('niuniu.hallOddsNx1') + 2
        ],
        pokers: getCardsDetailFromIds([48,44,40,36,4]),
        directions: $tFn('niuniu.niuTwoExplanation'),
    },
    {
        cardType: $tFn('niuniu.niuThree'),
        odds: [
            $tFn('niuniu.hallOdds3x1') + 1,
            $tFn('niuniu.hallOdds5x1') + 1,
            $tFn('niuniu.hallOddsNx1') + 3
        ],
        pokers: getCardsDetailFromIds([48,44,40,36,8]),
        directions: $tFn('niuniu.niuThreeExplanation'),
    },
    {
        cardType: $tFn('niuniu.niuFour'),
        odds: [
            $tFn('niuniu.hallOdds3x1') + 1,
            $tFn('niuniu.hallOdds5x1') + 1,
            $tFn('niuniu.hallOddsNx1') + 4
        ],
        pokers: getCardsDetailFromIds([48,44,40,36,12]),
        directions: $tFn('niuniu.niuFourExplanation'),
    },
    {
        cardType: $tFn('niuniu.niuFive'),
        odds: [
            $tFn('niuniu.hallOdds3x1') + 1,
            $tFn('niuniu.hallOdds5x1') + 1,
            $tFn('niuniu.hallOddsNx1') + 5
        ],
        pokers: getCardsDetailFromIds([48,44,40,36,16]),
        directions: $tFn('niuniu.niuFiveExplanation'),
    },
    {
        cardType: $tFn('niuniu.niuSix'),
        odds: [
            $tFn('niuniu.hallOdds3x1') + 1,
            $tFn('niuniu.hallOdds5x1') + 1,
            $tFn('niuniu.hallOddsNx1') + 6
        ],
        pokers: getCardsDetailFromIds([48,44,40,36,20]),
        directions: $tFn('niuniu.niuSixExplanation'),
    },
    {
        cardType: $tFn('niuniu.niuSeven'),
        odds: [
            $tFn('niuniu.hallOdds3x1') + 2,
            $tFn('niuniu.hallOdds5x1') + 2,
            $tFn('niuniu.hallOddsNx1') + 7
        ],
        pokers: getCardsDetailFromIds([48,44,40,36,24]),
        directions: $tFn('niuniu.niuSevenExplanation'),
    },
    {
        cardType: $tFn('niuniu.niuEight'),
        odds: [
            $tFn('niuniu.hallOdds3x1') + 2,
            $tFn('niuniu.hallOdds5x1') + 2,
            $tFn('niuniu.hallOddsNx1') + 8
        ],
        pokers: getCardsDetailFromIds([48,44,40,36,28]),
        directions: $tFn('niuniu.niuEightExplanation'),
    },
    {
        cardType: $tFn('niuniu.niuNine'),
        odds: [
            $tFn('niuniu.hallOdds3x1') + 2,
            $tFn('niuniu.hallOdds5x1') + 2,
            $tFn('niuniu.hallOddsNx1') + 9
        ],
        pokers: getCardsDetailFromIds([48,44,40,36,32]),
        directions: $tFn('niuniu.niuNineExplanation'),
    },
    {
        cardType: $tFn('niuniu.niuNiu'),
        odds: [
            $tFn('niuniu.hallOdds3x1') + 3,
            $tFn('niuniu.hallOdds5x1') + 3,
            $tFn('niuniu.hallOddsNx1') + 10
        ],
        pokers: getCardsDetailFromIds([48,49,44,32,0]),
        directions: $tFn('niuniu.niuNiuExplanation'),
    },
    {
        cardType: $tFn('niuniu.fiveFlower'),
        odds: [
            $tFn('niuniu.hallOdds3x1') + 3,
            $tFn('niuniu.hallOdds5x1') + 5,
            $tFn('niuniu.hallOddsNx1') + 10
        ],
        pokers: getCardsDetailFromIds([48,44,40,49,45]),
        directions: $tFn('niuniu.fiveFlowerExplanation'),
    },
    {
        cardType: $tFn('niuniu.fourBomb'),
        odds: [
            $tFn('niuniu.hallOdds3x1') + 3,
            $tFn('niuniu.hallOdds5x1') + 5,
            $tFn('niuniu.hallOddsNx1') + 10
        ],
        pokers: getCardsDetailFromIds([48,49,50,51,0]),
        directions: $tFn('niuniu.fourBombExplanation'),
    },
    {
        cardType: $tFn('niuniu.fiveSmall'),
        odds: [
            $tFn('niuniu.hallOdds3x1') + 3,
            $tFn('niuniu.hallOdds5x1') + 5,
            $tFn('niuniu.hallOddsNx1') + 10
        ],
        pokers: getCardsDetailFromIds([8,4,7,0,1]),
        directions: $tFn('niuniu.fiveSmallExplanation'),
    },
    
])
const colList = ref([
    {
        title: $tFn('niuniu.basicRulesTitle'),
        infos: [
            $tFn('niuniu.basicRules1'),
            $tFn('niuniu.basicRules2')
        ]
    },
    {
        title: $tFn('niuniu.comparisonRulesTitle'),
        infos: [
            $tFn('niuniu.comparisonRules1'),
            $tFn('niuniu.comparisonRules2'),
            $tFn('niuniu.comparisonRules3'),
            $tFn('niuniu.comparisonRules4')
        ]
    },
    {
        title: $tFn('niuniu.specialHandsTitle'),
        infos: [
            $tFn('niuniu.specialHands1'),
            $tFn('niuniu.specialHands2'),
            $tFn('niuniu.specialHands3')
        ]
    },
    {
        title: $tFn('niuniu.settlementRulesTitle'),
        infos: [
            $tFn('niuniu.settlementRules')
        ]
    },
    {
        title: $tFn('niuniu.commissionRulesTitle'),
        infos: [
            $tFn('niuniu.commissionRules1'),
            $tFn('niuniu.commissionRules2'),
            $tFn('niuniu.commissionRules3')
        ]
    },
])
</script>

<style lang="scss" scoped>
    .bg-title{
        font-size: 18px;
        color: white;
        font-weight: 600;
        line-height: 20px;
        letter-spacing: 0.3px;
        margin-bottom: 10px;
    }
    
    /* 扑克牌定位样式 - 扇形排列 */
    .pocker-img0 {
        position: absolute !important;
        left: 0px; /* 前三张牌 - 底牌 */
        z-index: 1;
    }
    .pocker-img1 {
        position: absolute !important;
        left: 12px; /* 前三张牌 - 中牌，距离底牌开头一半扑克牌距离(9px) */
        z-index: 2;
    }
    .pocker-img2 {
        position: absolute !important;
        left: 24px; /* 前三张牌 - 上牌，距离中牌开头一半扑克牌距离(9px) */
        z-index: 3;
    }
    .pocker-img3 {
        position: absolute !important;
        left: 44px;
        z-index: 4;
    }
    .pocker-img4 {
        position: absolute !important;
        left: 56px;
        z-index: 5; /* z-index从1到5，右侧卡牌显示在上层 */
    }
    
    /* 更紧凑的卡片行样式 - 用于容纳五张牌 */
    .cards-row-compact {
        display: flex;
        gap: 0;
        justify-content: center;
        position: relative;
        width: 130px;
        height: 50px;

        /* 调整扑克牌内部元素大小 - 适应18x24px尺寸 */
        :deep(.card) {
            border-radius: 2px; /* 设置卡牌圆角为2px */
        }
        :deep(.back){
            border-radius: 2px; /* 设置卡牌圆角为2px */
        }
        :deep(.card .corner) {
            font-size: 7px;  /* 原来是13px */
            left: 1px;      /* 原来是3px */
            top: 2px;       /* 原来是4px */
            letter-spacing: -0.5px; /* 更紧凑的字间距 */
        }
        :deep(.card .icon-bottom) {
            height: 10px;    /* 根据需求设置为12px */
            width: 10px;     /* 根据需求设置为12px */
            bottom: 2px;     /* 原来是4px */
        }
    }
    .card-introduction{
        border-radius: 12px;
        overflow: hidden;
        border: 1px solid var(--Text-Tertiary);
        overflow-x: scroll;
    }
    .card-title{
        ul{
            width:100%;
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            li{
                font-weight: 600;
                font-size: 12px;
                line-height: 14px;
                letter-spacing: 0.25px;
                text-align: center;
                border-bottom: 1px solid var(--color_grey-60);
            }
            li:nth-of-type(1){
                flex: 0 0 48px; /* 固定宽度48px */
            }
            li:nth-of-type(2){
                flex: 0 0 60px; /* 固定宽度60px */
            }
            li:nth-of-type(3){
                flex: 0 0 132px; /* 固定宽度132px */
            }
            li:nth-of-type(4){
                flex: 1;
                min-width: 83px; /* 容纳5张40px宽的扑克牌 */
            }
            li:nth-of-type(1),
            li:nth-of-type(2),
            li:nth-of-type(3){
                border-right: 1px solid var(--color_grey-60);
            }
        }
    }
    
    /* 游戏规则页面强制显示扑克牌正面 */
    .rules-face-up {
        :deep(.front) {
            transform: rotateY(0deg) !important; /* 强制显示正面 */
        }
        :deep(.back) {
            transform: rotateY(180deg) !important; /* 强制隐藏背面 */
        }
    }
    
    .card-list{
        ul{
            li{
                border-bottom: 1px solid var(--color_grey-60);
                .card-list_type,
                .card-list_odds,
                .card-list_directions{
                    border-right: 1px solid var(--color_grey-60);
                }
                .card-list_type{
                    flex: 0 0 48px;
                }
                .card-list_odds{
                    flex: 0 0 60px;
                }
                .card-list_directions{
                    flex: 0 0 132px;
                }
                .card-list_pokers{
                    flex: 1;
                    min-width: 83px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    :deep([class*="pocker-img"]){
                        border-radius: 3px;
                        .corner{
                            color: #1C2532;
                            font-weight: 400;
                            font-size: 7px;
                            left: 1px;
                            top: 0px;
                            letter-spacing: -0.5px;
                        }
                        svg{
                            width: 10px;
                            height: 10px;
                            bottom: 2px;
                        }
                    }
                }
                
            }
            li:nth-last-of-type(1){
                    border: none;
                }
        }
    }

    /* 小屏幕响应式样式 */
    @media (max-width: 768px) {
        .card-title {
            ul {
                li:nth-of-type(1){
                    flex: 0 0 48px;
                }
                li:nth-of-type(2){
                    flex: 0 0 60px;
                }
                li:nth-of-type(3){
                    flex: 1;
                    min-width: 60px;
                }
                li:nth-of-type(4){
                    flex: 0 0 75px;
                    max-width: 75px;
                }
            }
        }
        
        .card-list {
            ul {
                li {
                    .card-list_type{
                        flex: 0 0 48px;
                    }
                    .card-list_odds{
                        flex: 0 0 60px;
                    }
                    .card-list_directions{
                        flex: 1;
                        min-width: 60px;
                    }
                    .card-list_pokers{
                        // flex: 0 0 75px;
                        max-width: 75px;
                    }
                }
            }
        }
    }

    /* 滚动条优化样式 */
    .text-white {
        /* Webkit浏览器滚动条样式 */
        &::-webkit-scrollbar {
            width: 6px;
        }
        
        &::-webkit-scrollbar-track {
            background: rgba(255, 255, 255, 0.1);
            border-radius: 3px;
        }
        
        &::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.3);
            border-radius: 3px;
            transition: background 0.3s ease;
        }
        
        &::-webkit-scrollbar-thumb:hover {
            background: rgba(255, 255, 255, 0.5);
        }
        
        /* Firefox滚动条样式 */
        scrollbar-width: thin;
        scrollbar-color: rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.1);
    }

</style>
